export const handleDownload = () => {
  const filePath = '/MarcoContiResume.docx';  // Path to file in public folder
  const link = document.createElement('a');  // Create the link element
  link.href = filePath;  // Point to the correct file path
  link.download = 'MarcoContiResume.docx';  // The filename to be downloaded
  document.body.appendChild(link);  // Append to the body (required for older browsers)
  link.click();  // Trigger the click event to download the file
  document.body.removeChild(link);  // Clean up by removing the link
};
